import { render } from "./CardCarritoProductoComponent.vue?vue&type=template&id=3cdc808a&scoped=true"
import script from "./CardCarritoProductoComponent.vue?vue&type=script&lang=js"
export * from "./CardCarritoProductoComponent.vue?vue&type=script&lang=js"

import "./CardCarritoProductoComponent.vue?vue&type=style&index=0&id=3cdc808a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cdc808a"]])

export default __exports__